export default "__VITE_ASSET__DmTe9sHG__"